package com.loyola.acessoescola.ui.registered

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.loyola.acessoescola.data.JsonOutValues
import com.loyola.acessoescola.data.toJsonInValues
import com.loyola.acessoescola.services.QuickAuthClient
import com.loyola.acessoescola.services.quintadb.AcessoEscolaAPI
import com.loyola.acessoescola.services.quintadb.ExpiredTokenException
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class RegisteredViewModel(
    private val acessoEscolaAPI: AcessoEscolaAPI,
    private val quickAuthClient: QuickAuthClient
) : ViewModel() {
    private val _records = MutableStateFlow<List<JsonOutValues>>(listOf())
    val records: StateFlow<List<JsonOutValues>> get() = _records

    private val _uiState = MutableStateFlow(RegisteredState())

    val uiState: StateFlow<RegisteredState> = _uiState.asStateFlow()

    private fun onLoadingChange(state: Boolean) {
        _uiState.update { it.copy(isLoading = state) }
    }

    fun updateRecordList(onErrorCallback: (String?) -> Unit) {
        onLoadingChange(true)
        quickAuthClient.getCurrentAccount(
            onErrorCallBack = {
                onLoadingChange(false)
                onErrorCallback(it)
            },
        ) { _, userIDToken ->

            viewModelScope.launch {
                try {
                    acessoEscolaAPI.getRecords(userIDToken ?: "").collect { jsonOutValues ->
                        _records.update {
                            jsonOutValues
                        }
                    }
                } catch (e: ExpiredTokenException) {
                    onErrorCallback(e.message)
                    e.printStackTrace()
                    quickAuthClient.singout({}, onErrorCallback)
                    quickAuthClient.sign({}, onErrorCallback)

                } catch (e: Exception) {
                    e.printStackTrace()
                    onErrorCallback(e.message)
                } finally {
                    onLoadingChange(false)
                }
            }
        }
    }

    fun deleteRecord(recordID: String, onErrorCallback: (String?) -> Unit) {
        val record = _records.value.first { it.recordID == recordID }

        quickAuthClient.getCurrentAccount({}) { _, tokenID ->
            viewModelScope.launch {
                try {
                    acessoEscolaAPI.deleteRecord(
                        userIDToken = tokenID ?: "", record.toJsonInValues(),
                        onSuccessCallback = { updateRecordList(onErrorCallback) }
                    )
                } catch (e: ExpiredTokenException) {
                    onErrorCallback(e.message)
                    quickAuthClient.singout({}, onErrorCallback)
                    quickAuthClient.sign({}, onErrorCallback)
                } catch (e: Exception) {
                    onErrorCallback(e.message)
                }
            }

        }
    }
}